<template>
  <div class="phone-input-advanced">
    <div class="phone-wrapper">
      <!-- 区号选择器（支持搜索） -->
      <el-popover
        placement="bottom-start"
        width="300"
        trigger="click"
        v-model="popoverVisible"
      >
        <!-- 搜索框 -->
        <div class="country-search">
          <el-input
            :placeholder="lang.SearchCountry"
            v-model="searchKeyword"
            size="small"
            prefix-icon="el-icon-search"
          />
        </div>
        
        <!-- 国家列表 -->
        <div class="country-list">
          <div
            v-for="country in filteredCountries"
            :key="country.code+country.emoji"
            class="country-item"
            @click="selectCountry(country)"
          >
            <span class="country-emoji">{{ country.emoji }}</span>
            <span class="country-name">{{ country.name }}</span>
            <span class="country-code">{{ country.code }}</span>
          </div>
        </div>
        
        <!-- 触发器按钮 -->
        <el-button slot="reference" class="area-code-button" size="small">
          <span class="selected-emoji">{{ selectedCountry.emoji }}</span>
          <span class="selected-code">{{ selectedCountry.code }}</span>
          <i class="el-icon-arrow-down"></i>
        </el-button>
      </el-popover>
      
      <!-- 手机号输入 -->
      <el-input
        v-model="phoneNumber"
        :placeholder="lang.phone_text1"
        class="phone-input-advanced-field"
        @blur="validatePhone"
        @input="useTel"
        type="tel"
        size="small"
      />
    </div>
    
    <!-- 验证结果 -->
    <div class="validation-message" v-if="validationMessage" :class="validationType">
      {{ validationMessage }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {countriesWithValidation} from '@/utils/area.js'
import { create } from 'core-js/core/object';
export default {
  data() {
    return {
      selectedCountry: {
        name: '中国',
        code: '+86',
        emoji: '🇨🇳',
        pattern: /^1[3-9]\d{9}$/
      },
      phoneNumber: '',
      searchKeyword: '',
      popoverVisible: false,
      validationMessage: '',
      validationType: 'error',
      
      countries: countriesWithValidation
    }
  },
  computed: {
		...mapState({
			lang: state => state.user.lang,
		}),
    filteredCountries() {
      if (!this.searchKeyword) {
        return this.countries
      }
      return this.countries.filter(country => 
        country.name.includes(this.searchKeyword) || 
        country.code.includes(this.searchKeyword)
      )
    }
  },
  methods: {
    selectCountry(country) {
      this.selectedCountry = country
      this.popoverVisible = false
      this.searchKeyword = ''
      // 切换国家后清空输入和验证
      this.phoneNumber = ''
      this.validationMessage = ''
      this.$emit('countryChange', country)
    },
    useTel(e) {
      // 只允许输入数字
      this.phoneNumber = e.replace(/\D/g, '')
    },
    validatePhone() {
      if (!this.phoneNumber) {
        this.validationMessage = ''
        return
      }
      this.$emit('phoneNumberChange', this.phoneNumber)
      const isValid = this.selectedCountry.pattern.test(this.phoneNumber)
      
      if (isValid) {
        this.validationMessage = ``
        this.validationType = 'success'
      } else {
        this.validationMessage = this.lang.phone_text2
        this.validationType = 'error'
      }
    },
    
    // 获取完整手机号（用于提交）
    getFullPhoneNumber() {
      return {
        country: this.selectedCountry.name,
        areaCode: this.selectedCountry.code,
        phoneNumber: this.phoneNumber,
        fullNumber: `${this.selectedCountry.code} ${this.phoneNumber}`,
        isValid: this.selectedCountry.pattern.test(this.phoneNumber)
      }
    }
  }
}
</script>

<style scoped>
.phone-input-advanced {
  width: 100%;
}

.phone-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
}

.area-code-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 6px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.area-code-button:hover {
  border-color: #409eff;
}

.selected-emoji {
  font-size: 18px;
}

.selected-code {
  font-weight: 500;
  color: #606266;
}

.phone-input-advanced-field {
  flex: 1;
}

.country-search {
  padding: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.country-list {
  max-height: 300px;
  overflow-y: auto;
}

.country-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.country-item:hover {
  background: #f5f7fa;
}

.country-emoji {
  font-size: 18px;
  margin-right: 12px;
}

.country-name {
  flex: 1;
  font-size: 14px;
  color: #606266;
}

.country-code {
  font-size: 12px;
  color: #909399;
}

.validation-message {
  font-size: 12px;
  line-height: 12px;
  padding-left: 10px;
}

.validation-message.success {
  color: #67c23a;
}

.validation-message.error {
  color: #f56c6c;
}
</style>